const styles = {
  scroll__wheel: {
    height: '21.6em',
    overflowY: 'auto',
    width: '100%',
    position: 'fixed',
  },

  padding: {
    display: 'flex',
    flex: 1,
    paddingLeft: '1.9em',
    paddingBottom: '1.875em',
  },
};

export default styles;
